export { default } from './FinalSignatures';
export type { FinalSignaturesProps } from './FinalSignatures.types';
